export interface AuthProviderConfig {
  endpoint: string;
  displayName: string;
}

export const authProviders: Record<string, AuthProviderConfig> = {
  facebook: {
    endpoint: "/meta/auth/redirect",
    displayName: "Facebook",
  },
  threads: {
    endpoint: "/threads/auth/redirect",
    displayName: "Threads",
  },
  bluesky: {
    endpoint: "/bluesky/auth/redirect",
    displayName: "Bluesky",
  },
  mastodon: {
    endpoint: "/mastodon/auth/redirect",
    displayName: "Mastodon",
  },
};
